import { useTranslation } from 'react-i18next';

const ServicesSection = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    {
      icon: 'ri-brain-line',
      image: 'https://public.readdy.ai/ai/img_res/9a4ca86c4eef65b7e72d8932832ff6a0.jpg',
      title: t('services.service1.title'),
      description: t('services.service1.description')
    },
    {
      icon: 'ri-plant-line',
      image: 'https://readdy.ai/api/search-image?query=vertical%20hydroponic%20farming%20towers%20with%20fresh%20green%20lettuce%20and%20herbs%20growing%20in%20stacked%20layers%20under%20LED%20lights%20in%20indoor%20facility%20soilless%20agriculture%20system%20with%20nutrient%20solution%20pipes%20clean%20white%20background%20modern%20sustainable%20farming&width=600&height=400&seq=service002&orientation=landscape',
      title: t('services.service2.title'),
      description: t('services.service2.description')
    },
    {
      icon: 'ri-seedling-line',
      image: 'https://readdy.ai/api/search-image?query=traditional%20soil%20farming%20with%20rich%20dark%20earth%20and%20healthy%20seasonal%20crops%20growing%20in%20organized%20rows%20outdoor%20agricultural%20field%20with%20green%20plants%20and%20natural%20sunlight%20clean%20simple%20background%20representing%20quality%20organic%20farming%20practices&width=600&height=400&seq=service003&orientation=landscape',
      title: t('services.service3.title'),
      description: t('services.service3.description')
    },
    {
      icon: 'ri-file-list-3-line',
      image: 'https://readdy.ai/api/search-image?query=agricultural%20consulting%20and%20farm%20design%20blueprints%20on%20table%20with%20modern%20greenhouse%20model%20and%20planning%20documents%20professional%20business%20meeting%20setup%20with%20clean%20white%20background%20representing%20turnkey%20farm%20solutions%20and%20expert%20consultation%20services&width=600&height=400&seq=service004&orientation=landscape',
      title: t('services.service4.title'),
      description: t('services.service4.description')
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className={`mb-16 ${isRTL ? 'text-right' : 'text-left'}`}>
          <span className="inline-block bg-primary/10 text-primary px-4 py-2 rounded-lg font-tajawal text-sm mb-4">
            {t('services.label')}
          </span>
          <h2 className="font-almarai font-bold text-4xl md:text-5xl text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="font-tajawal text-lg text-gray-600 max-w-2xl">
            {t('services.subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className={`p-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                <div className={`flex items-center gap-3 mb-4 ${isRTL ? 'flex-row-reverse' : 'flex-row'}`}>
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className={`${service.icon} text-3xl text-primary`}></i>
                  </div>
                  <h3 className="font-almarai font-bold text-2xl text-gray-900">
                    {service.title}
                  </h3>
                </div>
                <p className="font-tajawal text-base text-gray-600 leading-relaxed mb-4">
                  {service.description}
                </p>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-primary font-tajawal text-sm hover:underline flex items-center gap-2 cursor-pointer flex-row-reverse"
                >
                  {t('services.readMore')}
                  <i className="ri-arrow-left-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;